export default __webpack_public_path__ + "static/media/profilePic3.32ca969a.png";